export default __webpack_public_path__ + "static/PromptIconFour-757b785f2ff87038bac1656446c3bb54.png";